"use client";
import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { useData } from '@/app/context/DataContext';
import "@/app/css/themes.css";
import Link from "next/link";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

function Header() {
  const [activeHeader, setActiveHeader] = useState(false);
  const [buildersEnabled, setBuildersEnabled] = useState(true);
  const [logoError, setLogoError] = useState(false);
  const pathname = usePathname();
  const { dynamicdata, dynamicloading, dynamicerror, refetch } = useData();

  // useEffect(() => {
  //   document.body.style.overflow = activeHeader ? "hidden" : "auto";
  // }, [activeHeader]);

  const menuItems = [
    { href: "/", label: "صفحه اصلی" },
    { href: "/properties", label: "املاک" },
    ...(buildersEnabled ? [{ href: "/builders", label: "انبوه" }] : []),
    { href: "/properties/requester", label: "فرم متقاضی" },
    { href: "/blog", label: "وبلاگ" },
    { href: "/contact", label: "تماس با ما" },
    { href: "/aboutus", label: "درباره ما" },
  ];

  let firstSegment = "/" + pathname.split("/")[1];

  if (pathname.split("/")[pathname.split("/").length - 1] === "Favorites") {
    firstSegment = "/properties/Favorites";
  }

  if (pathname.split("/")[pathname.split("/").length - 1] === "requester") {
    firstSegment = "/properties/requester";
  }

  const handleClick = () => { };

  const { data: session, status } = useSession();
  const router = useRouter();
  const [logined, setLogined] = useState(false);


  useEffect(() => {
    if (status === "authenticated") {
      setLogined(true)
    }
  }, [status, router]);

  useEffect(() => {
    const fetchBuildersSetting = async () => {
      try {
        const response = await fetch('/api/dynamicOptions');
        if (response.ok) {
          const data = await response.json();
          // Since builders_enabled is now a field in DynamicOptions, get the first record
          if (data && data.length > 0) {
            setBuildersEnabled(data[0].builders_enabled);
          }
        }
      } catch (error) {
        console.error('Error fetching builders setting:', error);
      }
    };
    fetchBuildersSetting();
  }, []);

  return (
    <>
      {/* نسخه دسکتاپ */}
      <header className="header hidden md:flex fixed top-10 justify-around xl:w-[80%] text-[var(--headertext)] lg:w-[95%] md:w-[95%] w-[95%] h-28 xl:right-[10%] lg:right-[2.5%] md:right-[2.5%] right-[2.5%] bg-[var(--headerback)] shadow-[var(--headershadow)] font-modam rounded-2xl z-100">
        <div className="logo w-35 flex items-center gap-3">
          <img
            src={logoError ? "media/logo.webp" : `/api/media/${dynamicdata?.logo}`}
            alt="pol logo"
            className="w-15 yeshadow"
            onError={() => setLogoError(true)}
          />
          <h2 className="font-bold text-2xl text-nowrap text-[var(--title)]">{dynamicdata?.siteName}</h2>
        </div>
        <nav className="flex items-center justify-center">
          <ul className="flex gap-10 lg:text-xm text-sm">
            {menuItems.map((item) => (
              <li
                key={item.href}
                className={`text-[var(--headertext)] ${firstSegment === item.href ? "active" : ""}`}
                onClick={() => {
                  setActiveHeader(false);
                }}
              >
                <Link href={item.href}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="buttons flex xl:gap-10 gap-10 items-center">
          {logined && session?.user.role !== 'منشی' && (
            <Link href={'/userPanel/properties/new'} className="cursor-pointer text-[var(--headertext)] hover:text-[var(--title)] transition">
              ثبت ملک
            </Link>
          )}
          {logined && session?.user.role === 'منشی' && (
            <Link href={'/userPanel/blog/new'} className="cursor-pointer text-[var(--headertext)] hover:text-[var(--title)] transition">
              ایجاد مقاله
            </Link>
          )}
          <Link href={`${logined ? '/userPanel' : '/login'}`} className="btngoldB ccdiv w-40 h-12 p-0  cursor-pointer text-[var(--headertext)]">
            {logined ? 'پنل ادمین' : 'ورود'}
          </Link>
        </div>
      </header>

      {/* نسخه موبایل */}
      <header
        className={`header ${activeHeader ? "active" : ""} md:hidden flex flex-col justify-start items-start px-6 fixed overflow-hidden top-[1%] left-[2%] w-[96%] h-20 rounded-lg bg-[var(--headerback)] shadow-[var(--headershadow)] z-1000`}
      >
        <div className="hed w-full min-h-20 flex justify-around items-center">
          <div
            className="bar w-[43px] h-[40px] ccdiv rounded-lg border border-[var(--foreground)]/20 cursor-pointer"
            onClick={() => setActiveHeader((prev) => !prev)}
          >
            <i className={`transition-all duration-500 ${activeHeader ? "ri-close-line rotate-90" : "ri-menu-line"}`}></i>
          </div>
          <div className="w-[100%] logo gap-2 flex justify-center items-center">
            <img src={`/api/media/${dynamicdata?.logo}`} alt="pol logo" className="w-[45px] md:w-[15%]" />
            <h2 className="text-2xl font-bold text-[var(--title)] text-center">{dynamicdata?.siteName}</h2>
          </div>
        </div>
        <nav className="border-t w-full pt-8 px-0 mt-1 flex flex-wrap justify-between">
          <Link href={`${logined ? '/userPanel' : '/login'}`} className="btngoldB ccdiv cursor-pointer text-[var(--headertext)] w-[100%] h-[50px] mb-7">
            {logined ? 'پنل ادمین' : 'ورود'}
          </Link>
          {logined && session?.user.role !== 'منشی' && (
            <Link href={'/userPanel/properties/new'} className="btngoldB ccdiv cursor-pointer text-[var(--headertext)] w-[47%] h-10">
              ثبت ملک
            </Link>
          )}
          {logined && session?.user.role !== 'ایجنت' && (
            <Link href={'/userPanel/blog/new'} className="btngoldB ccdiv cursor-pointer text-[var(--headertext)] w-[47%] h-10">
              ایجاد مقاله
            </Link>
          )}
          <ul className="flex flex-col items-start gap-7 text-lg [var(--headertext)] mt-10 px-5">
            {menuItems.map((item) => (
              <li
                key={item.href}
                className={`text-[var(--headertext)] ${firstSegment === item.href ? "active" : ""}`}
                onClick={() => {
                  setActiveHeader(false);
                }}
              >
                <Link href={item.href}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </header>
    </>
  );
}

export default Header;
